import type { Tester } from "../types";

interface TestingCompletePageProps {
  profile: Tester;
  contactEmail: string;
}

export function TestingCompletePage({ profile, contactEmail }: TestingCompletePageProps) {
  return (
    <div className="min-h-screen bg-[#fafaf7] flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center">
        <div className="text-5xl mb-4 text-emerald-700">✓</div>
        <h1 className="text-2xl font-semibold text-zinc-900 mb-2">Testing complete</h1>
        <p className="text-sm text-zinc-500 mb-2">
          Thanks for being part of the UAT, {profile.first_name}.
        </p>
        <p className="text-sm text-zinc-500 mb-6">
          All days of checks are done.
        </p>

        <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-4 text-left">
          <p className="text-xs text-emerald-900 leading-relaxed">
            We'll be in touch about the results shortly. Questions? Email{" "}
            <strong className="font-semibold">{contactEmail}</strong>.
          </p>
        </div>
      </div>
    </div>
  );
}
